import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import { CUSTOMER_GROUP_LABELS, GROUP_ID_PRO, GROUP_ID_STUDENT } from 'Route/MyAccount/MyAccount.config';

import './MyAccountBanner.style';

/** @namespace PeggysagePwa/Component/MyAccountBanner/Component */
export class MyAccountBannerComponent extends PureComponent {
    static propTypes = {
        isEnabled: PropTypes.bool.isRequired,
        isPro: PropTypes.bool.isRequired,
        isStudent: PropTypes.bool.isRequired
    };

    renderContent() {
        const { isPro } = this.props;

        const groupLabel = isPro
            ? CUSTOMER_GROUP_LABELS[GROUP_ID_PRO].singular
            : CUSTOMER_GROUP_LABELS[GROUP_ID_STUDENT].singular;

        const content = __('%s account', groupLabel);

        return (
            <div block="MyAccountBanner" elem="Content">
                { content }
            </div>
        );
    }

    render() {
        const { isEnabled, isPro, isStudent } = this.props;

        if (!isEnabled) {
            return null;
        }

        return (
            <div block="MyAccountBanner" mods={ { isPro, isStudent } }>
                { this.renderContent() }
            </div>
        );
    }
}

export default MyAccountBannerComponent;
